<template>
  <div class="component-container">
    <loading-state v-if="!loading" variant="migration" />
    <div v-else class="migration-container">
      <span v-if="!isExport" class="migration-title">Tabela de migração</span>
      <v-data-table :headers="headers" :items="items" hide-default-footer>
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <span>{{ item.name }}</span>
            </td>
            <td><img :src="require('@/assets/grey_arrow.svg')" alt="grey arrow" /></td>
            <td :style="{ backgroundColor: getBackgroundColor(item.key, 0) }">
              {{ localeString(item.champions) }}
              <mf-quick-actions
                v-if="item.champions > 0 && !isExport"
                ref="quickAction"
                :quick-action-group-id="`rfv-clients-group-from-${groupsKeys[0]}-to-${groupsKeys[item.key]}`"
                :short-description="getQuickActionDescription(item.key, 0)"
                :long-description="getQuickActionDescription(item.key, 0)"
                :segmentation-group="segmentationGroup(item.key, 0)"
              />
            </td>
            <td :style="{ backgroundColor: getBackgroundColor(item.key, 1) }">
              {{ localeString(item.loyals) }}
              <mf-quick-actions
                v-if="item.loyals > 0 && !isExport"
                ref="quickAction"
                :quick-action-group-id="`rfv-clients-group-from-${groupsKeys[1]}-to-${groupsKeys[item.key]}`"
                :short-description="getQuickActionDescription(item.key, 1)"
                :long-description="getQuickActionDescription(item.key, 1)"
                :segmentation-group="segmentationGroup(item.key, 1)"
              />
            </td>
            <td :style="{ backgroundColor: getBackgroundColor(item.key, 2) }">
              {{ localeString(item.promising) }}
              <mf-quick-actions
                v-if="item.promising > 0 && !isExport"
                ref="quickAction"
                :quick-action-group-id="`rfv-clients-group-from-${groupsKeys[2]}-to-${groupsKeys[item.key]}`"
                :short-description="getQuickActionDescription(item.key, 2)"
                :long-description="getQuickActionDescription(item.key, 2)"
                :segmentation-group="segmentationGroup(item.key, 2)"
              />
            </td>
            <td :style="{ backgroundColor: getBackgroundColor(item.key, 3) }">
              {{ localeString(item.atRisk) }}
              <mf-quick-actions
                v-if="item.atRisk > 0 && !isExport"
                ref="quickAction"
                :quick-action-group-id="`rfv-clients-group-from-${groupsKeys[3]}-to-${groupsKeys[item.key]}`"
                :short-description="getQuickActionDescription(item.key, 3)"
                :long-description="getQuickActionDescription(item.key, 3)"
                :segmentation-group="segmentationGroup(item.key, 3)"
              />
            </td>
            <td :style="{ backgroundColor: getBackgroundColor(item.key, 4) }">
              {{ localeString(item.lowValue) }}
              <mf-quick-actions
                v-if="item.lowValue > 0 && !isExport"
                ref="quickAction"
                :quick-action-group-id="`rfv-clients-group-from-${groupsKeys[4]}-to-${groupsKeys[item.key]}`"
                :short-description="getQuickActionDescription(item.key, 4)"
                :long-description="getQuickActionDescription(item.key, 4)"
                :segmentation-group="segmentationGroup(item.key, 4)"
              />
            </td>
            <td :style="{ backgroundColor: getBackgroundColor(item.key, 5) }">
              {{ localeString(item.losses) }}
              <mf-quick-actions
                v-if="item.losses > 0 && !isExport"
                ref="quickAction"
                :quick-action-group-id="`rfv-clients-group-from-${groupsKeys[5]}-to-${groupsKeys[item.key]}`"
                :short-description="getQuickActionDescription(item.key, 5)"
                :long-description="getQuickActionDescription(item.key, 5)"
                :segmentation-group="segmentationGroup(item.key, 5)"
              />
            </td>
          </tr> </template
      ></v-data-table>
    </div>
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'
import { rfvAnalysis } from '../../../mixins/analise-rfv'
import { mapState } from 'vuex'
import { criteriaGroup, rfvClientsGroupCriteria, isInSegmentCriteria } from '@/components/quick-actions/segmentationGroups.js'
import LoadingState from './LoadingState.vue'
export default {
  name: 'MigrationTable',
  components: {
    LoadingState,
  },
  mixins: [rfvAnalysis],
  props: {
    loadingReferencePeriod: {
      type: Boolean,
      default: true,
    },
    loadingCurrentPeriod: {
      type: Boolean,
      default: true,
    },
    isExport: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    groups: ['campeões', 'leais', 'promissores', 'em risco', 'baixo valor', 'perdidos', 'nunca compraram'],
    groupsKeys: ['champions', 'loyals', 'promising', 'atRisk', 'lowValue', 'losses', 'neverBought'],
  }),
  computed: {
    ...mapState({ stateFilters: (state) => state.filters }),
    loading() {
      return !this.loadingCurrentPeriod && !this.loadingReferencePeriod
    },
    headers() {
      return [
        {
          text: 'Segmento anterior',
          value: 'previous_segment',
          width: this.isExport ? '140px' : '10%',
          sortable: false,
        },
        {
          text: 'para',
          value: 'arrow',
          width: this.isExport ? '60px' : '5%',
          sortable: false,
        },
        {
          text: 'Campeões',
          value: 'champions',
          width: this.isExport ? '' : '12%',
          sortable: false,
        },
        {
          text: 'Leais',
          value: 'loyals',
          width: this.isExport ? '' : '12%',
          sortable: false,
        },
        {
          text: 'Promissores',
          value: 'promising',
          width: this.isExport ? '' : '12%',
          sortable: false,
        },
        {
          text: 'Em risco',
          value: 'atRisk',
          width: this.isExport ? '' : '12%',
          sortable: false,
        },
        {
          text: 'Baixo valor',
          value: 'lowValue',
          width: this.isExport ? '' : '12%',
          sortable: false,
        },
        {
          text: 'Perdidos',
          value: 'losses',
          width: this.isExport ? '' : '12%',
          sortable: false,
        },
      ]
    },
    items() {
      if (this.periodMigrations) {
        const { champions, loyals, promising, atRisk, lowValue, losses, neverBought } = this.periodMigrations
        return [
          { ...champions, name: 'Campeões', key: 0 },
          { ...loyals, name: 'Clientes leais', key: 1 },
          { ...promising, name: 'Promissores', key: 2 },
          { ...atRisk, name: 'Em risco', key: 3 },
          { ...lowValue, name: 'Baixo valor', key: 4 },
          { ...losses, name: 'Perdidos', key: 5 },
          { ...neverBought, name: 'Nunca compraram', key: 6 },
        ]
      } else return []
    },
  },
  methods: {
    localeString,
    getQuickActionDescription(fromValue, toValue) {
      return `Clientes que migraram do grupo ${this.groups[fromValue]} para o grupo ${this.groups[toValue]}.`
    },
    segmentationGroup(fromClientId, toClientId) {
      const criteria = [
        rfvClientsGroupCriteria(this.analyticsConfiguration._id, this.referencePeriod._id, [this.clientTypesToSegmentCluster[this.groupsKeys[fromClientId]]]),
        rfvClientsGroupCriteria(this.analyticsConfiguration._id, this.currentPeriod._id, [this.clientTypesToSegmentCluster[this.groupsKeys[toClientId]]]),
      ]
      if (this.stateFilters.segmentsObjects?.length) {
        this.stateFilters.segmentsObjects.forEach((segment) => {
          criteria.push(isInSegmentCriteria(segment))
        })
      }
      return criteriaGroup(criteria)
    },
    getBackgroundColor(itemKey, tdKey) {
      if (itemKey === tdKey) {
        return '#ECEDF0'
      } else if (itemKey > tdKey) {
        return '#C8E39C'
      } else {
        return '#F3C7BF'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.component-container {
  width: 100%;
  .migration-container {
    width: 100%;
    .migration-title {
      color: $cinza-d10;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.333px;
      height: 32px;
    }
  }
}

::v-deep .v-data-table tr {
  border-bottom: solid 8px white;
  td {
    padding: 8px 12px;
    color: var(--Cinza-D20, #31363b);
    font-size: 14px;
    font-weight: 600;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.4px;
  }
  td:first-child {
    padding: 15px 8px;
    span {
      color: $cinza-d20;
      font-size: 14px;
      font-weight: 700;
      line-height: 120%; /* 16.8px */
      letter-spacing: 0.14px;
    }
  }
  td:nth-child(2) {
    padding: 0;
  }
  th:first-child {
    span {
      color: $cinza-0;
      font-family: Lato;
      font-size: 14px;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: 0.14px;
    }
  }
  th:nth-child(2) {
    span {
      color: $cinza-0;
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
::v-deep .v-data-table th {
  padding: 15px 8px;
  span {
    color: $cinza-d20;
    font-size: 14px;
    font-weight: 700;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.14px;
  }
}

::v-deep th,
td {
  border-bottom: none !important;
}
</style>
